import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faCalendarDay,
  faCalendarDays,
  faGear,
  faTicket,
  faUserGroup,
  faWineGlass,
} from '@fortawesome/free-solid-svg-icons';

export interface NavItem {
  id: string;
  labelKey: string;
  icon: IconDefinition;
  route: string;
  /** Where staff go instead (Settings opens their own account). */
  staffRoute?: string;
}

export const DAILY_ITEMS: readonly NavItem[] = [
  { id: 'today', labelKey: 'nav.today', icon: faCalendarDay, route: '/today' },
  { id: 'calendar', labelKey: 'nav.calendar', icon: faCalendarDays, route: '/calendar' },
  { id: 'bookings', labelKey: 'nav.bookings', icon: faTicket, route: '/bookings' },
];

export const SET_UP_ITEMS: readonly NavItem[] = [
  { id: 'experiences', labelKey: 'nav.experiences', icon: faWineGlass, route: '/experiences' },
  { id: 'guests', labelKey: 'nav.guests', icon: faUserGroup, route: '/guests' },
  { id: 'settings', labelKey: 'nav.settings', icon: faGear, route: '/settings', staffRoute: '/settings/account' },
];
